var React = require('react');

function ThorgateLogoNoText (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M140.294 281.99C62.811 281.99 0 218.86 0 140.99C0 63.12 62.811 0 140.294 0C217.777 0 280.587 63.13 280.587 140.99C280.587 218.85 217.776 281.99 140.294 281.99ZM140.25 228.06L189.86 205.9V135.88L172 132.4L171.985 194.03L140.247 208.32L108.87 194.02L108.877 132.37L91.006 135.86V206.01L140.25 228.06ZM189.86 69.6699L140.281 61.02L91.009 69.6699V87.9399L140.281 79.21L189.86 87.9399V69.6699ZM199.06 99.4099L140.277 87.97L81.858 99.3799V128.29L118.026 121.2V188.19L140.277 198.15L162.827 188.19V121.25L199.06 128.33V99.4099Z"}));
}

ThorgateLogoNoText.defaultProps = {"viewBox":"0 0 281 282"};

module.exports = ThorgateLogoNoText;

ThorgateLogoNoText.default = ThorgateLogoNoText;
